import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferDetailQuery, OfferDigitalProductDetailVo, OfferGameServiceDetailVo } from './type';

/**
 * c端 查询数字商品offer 详情
  GET /product/offerManage/getDigitalProductDetailVo
  接口ID：263628568
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628568
 */
export const getOfferDigitalProductDetail = (params: OfferDetailQuery): AxiosPromise<OfferDigitalProductDetailVo> => {
  return request({
    url: '/product/offerManage/getDigitalProductDetailVo',
    method: 'get',
    params
  });
};

/**
 * c端 查询game service offer 详情
  GET /product/offerManage/getGameServiceProductDetailVo
  接口ID：263628564
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628564
 */
export const getOfferGameServiceDetail = (params: OfferDetailQuery): AxiosPromise<OfferGameServiceDetailVo> => {
  return request({
    url: '/product/offerManage/getGameServiceProductDetailVo',
    method: 'get',
    params
  });
};
